export default class Lazy
{
	constructor()
	{
		this.init();
	}

	init()
	{
		this.images = document.querySelectorAll('.lazy');
		this.images.length > 0 && this.initLazy();
	}

	initLazy()
	{
		if(this.observer)
			this.observer.disconnect();

		this.observer = new IntersectionObserver((objects) =>
		{
			for(let i = 0; i < objects.length; i++)
			{
				const object = objects[i];

				if(object.intersectionRatio > 0)
				{
					const target = object.target;

					if(target.tagName !== 'IMG' && target.tagName !== 'EMBED')
					{
						target.style.backgroundImage = 'url(' + target.dataset.src + ')';
						target.classList.remove('lazy');
					}
					else
					{
						target.addEventListener(
							'load',
							this.onLoad.bind(this, target)
						);

						if(target.dataset.src)
							target.src = target.dataset.src;

						if(target.dataset.srcset)
							target.srcset = target.dataset.srcset;
					}

					this.observer.unobserve(target);
				}
			}
		},
		{
			rootMargin: '20px 0px',
			threshold: 0.01
		});

		for(let i = 0; i < this.images.length; ++i)
			this.observer.observe(this.images[i]);
	}

	onLoad(target)
	{
		target.removeEventListener('load', this.onLoad.bind(this, target), true);
		target.classList.remove('lazy');
	}
}
